import InboxTableProvider, {
  TypeListRequest,
  QuickFilterType
} from "../../pages/inbox/InboxTableProvider";
import { FloatingWhatsAppUI } from "./FloatingWhatsAppUI";
import CompanyService from "../../services/CompanyService";

const whatsappInitialRequest = new TypeListRequest(QuickFilterType.Whatsapp);

export const WhatsappBase = () => {
  if (!CompanyService.canUseWhatsappNotifications()) return null;
  return (
    <InboxTableProvider prevRequest={whatsappInitialRequest}>
      <FloatingWhatsAppUI />
    </InboxTableProvider>
  );
};
